<div class="container-inputs">
  <div class="travel-calendar-flight-type" *ngIf="showCalendarFlightInputs">
    <ng-container *ngTemplateOutlet="flighTypeOptions"></ng-container>
  </div>
</div>

<ng-template #flighTypeOptions>
  <div class="calendarInputs__radio" *ngFor="let type of flightTypes">
    <app-ds-radio-button
      [checked]="isActiveFlightType(type)"
      [title]="{ Label: 'SEARCH_MODULE.FLIGHT_TYPE.' + type | transloco }"
      (radioOnChecked)="flightTypeSelected(type)">
    </app-ds-radio-button>
  </div>
</ng-template>
